<template>
    <div>项目异议</div>
</template>


<script>
    export default {
        props: {
            projectId: {
                type: String,
                required: true
            },
            random: {
                type: String,
                default: '',
                required: false
            }
        },
        created() {
            this.initData();
        },
        watch: {
            random: {
                immediate: true,
                handler(newValue,oldValue) {
                    if (newValue !== oldValue) {
                        // console.log("has listened data!")
                        this.initData();
                    }
                }
            }
        },
        name: "DissentInfo",
        data() {
            return {
                bondList: [],
                current: 1,
                pageList: []
            }
        },
        methods: {
            initData() {
            }
        }
    }
</script>

<style scoped>

</style>
